import { RootState } from '../../../../utils/type';

export const selectStationsByVendor = (vendorId: number | undefined) => (state: RootState) =>
  state.stationList.byVendor[vendorId !== undefined ? String(vendorId) : 'all'] ?? [];

export const selectStationListLoading = (state: RootState) => state.stationList.loading;
export const selectStationListError = (state: RootState) => state.stationList.error;
